<template>
    <Modal
        name="admin-book-controls"
        :title="$t('adminBookControls.title')"
        @closed="$emit('closed')"
    >
        <template #content>
            <form class="admin-book-controls" @submit.prevent="addContractor">
                <Spinner v-if="loading" />
                <h3>{{ $t('adminBookControls.contractors') }}</h3>
                <div class="admin-book-controls__contractors">
                    <ul v-if="bookContractors.length">
                        <li v-for="cont in bookContractors" :key="cont.id">
                            {{ cont.contractor.name }}
                        </li>
                    </ul>
                    <span v-else>{{ $t('adminBookControls.noContractors') }}</span>
                </div>
                <div class="form-group">
                    <div class="form-group__label">{{ $t('adminBookControls.addContractor') }}</div>
                    <div class="admin-book-controls__add-contractor">
                        <CustomSelect
                            v-model="contractor"
                            :options="contractors"
                            emit-prop="id"
                            view-label="name"
                            :empty-text="$t('adminBookControls.noContractors')"
                            :placeholder="$t('adminBookControls.contractor')"
                            width="240px"
                            style="margin-right: 20px"
                        />
                        <CustomSelect
                            v-model="buildType"
                            :options="buildTypes"
                            emit-prop="name"
                            view-label="label"
                            :placeholder="$t('adminBookControls.buildType')"
                            width="240px"
                        />
                        <button
                            type="submit"
                            class="button"
                            style="margin-left: 20px"
                            :disabled="invalidContractor"
                            :class="{ 'is-disabled': invalidContractor }"
                        >
                            {{ $t('misc.add') }}
                        </button>
                    </div>
                </div>
            </form>
            <div v-if="bookContractors.length" class="admin-book-controls__table-wrap">
                <table class="control-table">
                    <thead class="control-table__head">
                        <tr class="control-table__row">
                            <th class="control-table__cell">
                                {{ $t('adminBookControls.book') }}
                            </th>
                            <th class="control-table__cell" style="width: 14%">
                                {{ $t('adminBookControls.buildType') }}
                            </th>
                            <th class="control-table__cell" style="width: 15%">
                                {{ $t('adminBookControls.contractor') }}
                            </th>
                            <th class="control-table__cell">
                                {{ $t('adminBookControls.status') }}
                            </th>
                            <th class="control-table__cell"></th>
                        </tr>
                    </thead>
                    <tbody class="control-table__body">
                        <ContractedBookCard
                            v-for="book in bookContractors"
                            :key="book.id"
                            :states="states"
                            single
                            :book="book"
                            @statusChanged="fetchData"
                        />
                    </tbody>
                </table>
            </div>
        </template>
    </Modal>
</template>

<script>
// @todo will move to manage (?)

import { CustomSelect } from '@speechki-frontend/shared/ui/forms';
import { Modal } from '@speechki-frontend/shared/ui/modals';
import ContractedBookCard from '../ContractedBookCard/ContractedBookCard';

import { mapGetters, mapState, mapActions } from 'vuex';

export default {
    name: 'AdminBookControls',
    components: {
        Modal,
        CustomSelect,
        ContractedBookCard,
    },
    props: {
        bookId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            contractor: null,
            buildType: null,
            loading: false,
            bookContractors: [],
        };
    },
    computed: {
        ...mapGetters(['isAdmin', 'isStaff', 'isListener']),
        ...mapState({
            contractors: (state) => state.contractors.contractors,
            buildTypes: (state) => state.contractors.buildTypes,
            states: (state) => state.contractors.states,
        }),
        bookContractorsIds() {
            if (!this.bookContractors.length) return [];
            return this.bookContractors.map((cont) => cont.contractor.id);
        },
        invalidContractor() {
            if (!this.contractor || !this.buildType || this.loading) return true;

            let exists = this.bookContractors.find(
                (bc) =>
                    bc.contractor.id === this.contractor && bc.build_type.label === this.buildType
            );

            return !!exists;
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        ...mapActions(['fetchContractors', 'fetchStates', 'fetchBuildTypes']),
        async addContractor() {
            if (this.invalidContractor) return;
            try {
                this.loading = true;
                await this.$http.post('/api/v1/contractors_books/', {
                    book: this.bookId,
                    contractor: this.contractor,
                    build_type: this.buildType,
                });
                this.contractor = null;
                this.buildType = null;
                await this.fetchData();
                this.loading = false;
            } catch (e) {
                alert('Ошибка: ' + e.detail);
                this.loading = false;
            }
        },
        async fetchBookContractors() {
            const { results } = await this.$http.get('/api/v1/contractors_books/', {
                params: {
                    book: this.bookId,
                },
            });
            this.bookContractors = results;
        },
        async fetchData() {
            this.loading = true;
            let promises = [this.fetchBookContractors()];

            if (!this.contractors.length) {
                promises.unshift(this.fetchContractors());
            }

            if (!this.buildTypes.length) {
                promises.unshift(this.fetchBuildTypes());
            }

            if (!this.states.length) {
                promises.unshift(this.fetchStates());
            }

            await Promise.all(promises);
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" src="./AdminBookControls.scss"></style>
